// import StageOne from "../Views/StageOne";
import StageOne from "../Views/StageOne";

const routes = [{ path: "/stage-one", element: <StageOne /> }];

export default routes;
